<template>
  <a-drawer
    title="编辑协议"
    placement="right"
    :closable="true"
    :visible="visible"
    @close="onClose"
    width="450"
  >
    <a-form-model
      ref="form"
      :model="formData"
      :rules="rules"
    >
      <a-form-model-item
        label="标题名称"
        prop="title"
      >
        <a-input
          v-model="formData.title"
          placeholder="请输入标题名称"
          allowClear
        />
      </a-form-model-item>
      <a-form-model-item
        label="协议内容"
        prop="content"
      >
        <wang-editor :defaultValue="formData.content" @change="changeContent" />
      </a-form-model-item>
    </a-form-model>
    <div
      :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #394555',
        padding: '10px 16px',
        background: '#394555',
        textAlign: 'right',
        zIndex: 1,
      }"
    >
      <a-button :style="{ marginRight: '8px' }" @click="onClose">
        取消
      </a-button>
      <a-button type="primary" @click="handleSave">
        保存
      </a-button>
    </div>
  </a-drawer>
</template>

<script>
import { getAgreementDetail, postAgreementEdit } from '@/api/agreement'
import wangEditor from '@/components/wangEditor'

const defaultFormData = {
  agree_id: '',
  title: '',
  content: ''
}

export default {
  components: { wangEditor },
  data() {
    return {
      id: '',
      visible: false,
      formData: Object.assign({}, defaultFormData),
      rules: {
        title: [{ required: true, message: '标题名称必填' }]
        // content: [{ required: true, message: '协议内容必填' }]
      }
    }
  },
  methods: {
    showModal(id) {
      this.id = id
      this.visible = true
      this.getDetail()
    },
    onClose() {
      this.visible = false
    },
    // 详情
    getDetail() {
      getAgreementDetail({
        agree_id: this.id
      })
        .then((res) => {
          if (res.code === 200) {
            const { data } = res
            this.formData = data
          }
        })
        .catch((e) => {
          this.$message.error('请求协议详情失败')
        })
    },
    // 保存
    handleSave() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.postEdit()
        } else {
          this.$message.error('还有字段未填写，请检查！')
          return false
        }
      })
    },
    // 编辑
    postEdit() {
      postAgreementEdit({
        agree_id: this.id,
        title: this.formData.title,
        content: this.formData.content
      })
        .then((res) => {
          if (res.code === 200) {
            this.$message.success('协议保存成功')
            this.$emit('success')
            this.onClose()
          }
        })
        .catch((e) => {
          this.$message.error('请求编辑协议失败')
        })
    },
    /**
     * 修改协议内容
     */
    changeContent(html) {
      this.formData.content = html
    }
  }
}
</script>
<style lang="less">
.qrcode {
  width: 200px;
  height: 200px;
  background-color: #eee;
  margin: 0 auto;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  .loading {
    position: absolute;
    top: 0;
    left: 0;
  }
  .fresh-qrcode-btn {
    position: absolute;
    right: -50px;
    top: 50%;
    transform: translateY(-50%);
  }
}
.money {
  text-align: center;
  font-size: 18px;
  margin: 10px 0;
}
.red {
  color: red;
}
.fw-b {
  font-weight: bolder;
}
.cus-radio-group {
  display: flex;
  .cus-radio {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 10px 20px;
    border: 1px solid #eee;
    margin: 10px;
    flex: 1;
    &.active {
      border: 1px solid yellow;
      background: rgba(110, 110, 110, 0.5);
      box-shadow: 0 0 4px 2px #f7ff2cb8;
    }
  }
}
</style>
